import React from 'react';

export default function ExploreMission({ title, description, tasks = [] }) {
  return (
    <section className="explore-mission">
      <div>
        <p className="explore-eyebrow">Mission</p>
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      <ul>
        {tasks.map((task, index) => (
          <li key={task}>
            <span>{index + 1}</span>
            {task}
          </li>
        ))}
      </ul>
    </section>
  );
}
